import { Inject, Injectable, forwardRef} from '@angular/core';
import { FiscalYear } from '../../entities/fiscal-year';
import { Http, Response } from '@angular/http';

import { HttpClient } from './http-client.service';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { Settings } from '../../settings';
import { DateConverter } from '../../utility/date-converter';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';
import { CachedCallService } from './cached-call.service';

@Injectable()
export class FiscalYearService {
  private static readonly fiscalYearUrl:string = `${Settings.apiUrl}/v1/FiscalYears`;

  public fiscalYears:FiscalYear[] = [];

  public selectableYears:FiscalYear[] = [];

  public selectedFiscalYear:FiscalYear = new FiscalYear();

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

    // public getFiscalYears():Promise<FiscalYear[]>{
      
    //   return this.cachedCallService.invokeSingleCall(
    //     () => {
      
    //       let oDataBuilder:ODataBuilder = new ODataBuilder(FiscalYearService.fiscalYearUrl);

    //       oDataBuilder
    //         .orderBy("StartDate");

    //       let fiscalYearUrl:string = oDataBuilder.toString();

    //       return this.http.get(fiscalYearUrl)
    //               .toPromise()
    //               .then(response => {
    //                 //I'm using "any" and not FiscalYear because FiscalYear thinks that 
    //                 //StartDate and EndDate are already dates, but they are not yet
    //                 //until they are converted
    //                 let formattedResponse:any[] = response.json().value;

    //                 formattedResponse.forEach(fiscalYear => {
    //                   fiscalYear.StartDate = DateConverter.convertDate(fiscalYear.StartDate);
    //                   fiscalYear.EndDate = DateConverter.convertDate(fiscalYear.EndDate);
    //                 });

    //                 this.fiscalYears = formattedResponse;

    //                 let now = new Date();
                    
    //                 let oneYearAgo = new Date();
    //                 oneYearAgo.setFullYear(now.getFullYear() - 1);

    //                 let oneYearFromNow = new Date();
    //                 oneYearFromNow.setFullYear(now.getFullYear() + 1);

    //                 this.selectableYears = this.fiscalYears;

    //                 // this.selectableYears = this.fiscalYears.filter(
    //                 //   year =>
    //                 //     {
    //                 //       return  now > year.StartDate && now < year.EndDate ||
    //                 //               oneYearAgo > year.StartDate && oneYearAgo < year.EndDate ||
    //                 //               oneYearFromNow > year.StartDate && oneYearFromNow < year.EndDate;
    //                 //     }
    //                 // );

    //                 return formattedResponse;  
    //               });
    //     }, "getFiscalYears"
    //   );
    // }

  // removed the caching of Fiscal Years b/c when 401 is returned for initial page the empty result set was getting cached
  // after logging in the empty result set was then returned instead of fetching the fiscal years from the server
  public getFiscalYears(): Promise<FiscalYear[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(FiscalYearService.fiscalYearUrl);

    oDataBuilder
      .orderBy("StartDate");

    let fiscalYearUrl: string = oDataBuilder.toString();

    return this.http.get(fiscalYearUrl)
      .toPromise()
      .then(response => {
        //I'm using "any" and not FiscalYear because FiscalYear thinks that 
        //StartDate and EndDate are already dates, but they are not yet
        //until they are converted
        let formattedResponse: any[] = response.json().value;

        formattedResponse.forEach(fiscalYear => {
          fiscalYear.StartDate = DateConverter.convertDate(fiscalYear.StartDate).toUTC();
          fiscalYear.EndDate = DateConverter.convertDate(fiscalYear.EndDate).toUTC();
        });

        this.fiscalYears = formattedResponse;

        let now = DateConverter.convertDate(new Date()).toUTCDateOnly();;

        let oneYearAgo = DateConverter.convertDate(new Date()).toUTCDateOnly();;
        oneYearAgo.setFullYear(now.getFullYear() - 1);

        let oneYearFromNow = DateConverter.convertDate(new Date()).toUTCDateOnly();;
        oneYearFromNow.setFullYear(now.getFullYear() + 1);

        this.selectableYears = this.fiscalYears;

        // this.selectableYears = this.fiscalYears.filter(
        //   year =>
        //     {
        //       return  now > year.StartDate && now < year.EndDate ||
        //               oneYearAgo > year.StartDate && oneYearAgo < year.EndDate ||
        //               oneYearFromNow > year.StartDate && oneYearFromNow < year.EndDate;
        //     }
        // );

        return formattedResponse;
      });
  }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/fiscal-year.service.ts